import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 达人排行榜-详情
export const rankingAnchorDetail = params => {
	return request({
		url: '/api/ranking/anchor-detail',
		data: params,
		method: AjaxMethod.post,
	});
};

// 设置排行榜查看权限
export const rankingSetViewConfig = params => {
	return request({
		url: '/api/ranking/set-view-config',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取排行榜查看权限
export const rankingGetViewConfig = params => {
	return request({
		url: '/api/ranking/get-view-config',
		data: params,
		method: AjaxMethod.post,
	});
};

// 商品排行榜-详情
export const rankingProductDetail = params => {
	return request({
		url: '/api/ranking/product-detail',
		data: params,
		method: AjaxMethod.post,
	});
};

// 达人排行榜-商品列表
export const rankingAnchorProducts = params => {
	return request({
		url: '/api/ranking/anchor-products',
		data: params,
		method: AjaxMethod.post,
	});
};

// 商品排行榜-达人列表
export const rankingProductAnchors = params => {
	return request({
		url: '/api/ranking/product-anchors',
		data: params,
		method: AjaxMethod.post,
	});
};

// 商品排行榜-二级团长列表
export const rankingProductSecondarys = params => {
	return request({
		url: '/api/ranking/product-secondarys',
		data: params,
		method: AjaxMethod.post,
	});
};

// 二级团长排行榜-商品列表
export const rankingSecondaryProducts = params => {
	return request({
		url: '/api/ranking/secondary-products',
		data: params,
		method: AjaxMethod.post,
	});
};

// 二级团长排行榜-商品列表
export const rankingSecondaryDetail = params => {
	return request({
		url: '/api/ranking/secondary-detail',
		data: params,
		method: AjaxMethod.post,
	});
};

// 排行榜-首页
export const rankingHome = params => {
	return request({
		url: '/api/ranking/home',
		data: params,
		method: AjaxMethod.post,
	});
};

// 榜单导出
export const rankingExport = params => {
	return request({
		url: '/api/ranking/export',
		data: params,
		method: AjaxMethod.post,
	});
};
